import { getAxiosConfig } from '../apisSetup/apiConfig';
import { PATHS } from 'AppConstants';

const ccbAxiosApiCaller = getAxiosConfig(PATHS.CCB_URL, true, {
}, false);

export const getEmpList = (apidata, isSearch) => {
	const api = isSearch ? PATHS.SEARCH_EMPLOYEE_LIST : PATHS.GET_EMPLOYEE_LIST;
	return ccbAxiosApiCaller.post(api, apidata);
};

export const updateBulkData = (apidata) => ccbAxiosApiCaller.put(PATHS.BULK_UPDATE_EMP, apidata);

export const downloadEmpData = (apidata) => ccbAxiosApiCaller.post(PATHS.DWL_EMP_DATA, apidata);

export const downloadCSv = (apidata) => ccbAxiosApiCaller.get(PATHS.DWL_EMP_JOB, { params: apidata });

export const getUpdateStatusApi = (apidata) => ccbAxiosApiCaller.post(PATHS.UPDATE_POLL, apidata);

export const updateJobStatus = (apidata) => ccbAxiosApiCaller.post(PATHS.UPDATE_JOB_STATUS, apidata);

export const downloadDataFromurl = (apidata) => ccbAxiosApiCaller.get(PATHS.DWL_MAILER_URL, { params: apidata });

export const getInviteChannel = (apidata) => ccbAxiosApiCaller.get(PATHS.INVITE_CHANNELS);

export const updateInviteChannel = (apidata) => ccbAxiosApiCaller.post(PATHS.INVITE_CHANNELS, apidata);
